<template>
  <div>
    <el-tabs v-model="activeTabName">
      <el-tab-pane name="投票" label="投票">
        <CorpFlowVotesPage v-if="activeTabName == '投票'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CorpFlowVotesPage from "./tab-pages/CorpFlowVotesPage";
export default {
  data() {
    return {
      activeTabName: "投票",
    };
  },

  components: { CorpFlowVotesPage },
};
</script>